import React, { useState, useMemo } from 'react';
import { useSelector } from 'react-redux';

import Path from 'routes/Path';
import { userRoles } from 'constants/users';
import { Images } from 'assets/images';
import {
  DropdownContent,
  HeaderNav,
  LogoImg,
  MenuIcon,
  NavbarContents,
  HeaderContentRow,
  HeaderLink,
  LinkSpacer,
} from './styles';
import UserDetails from './UserDetails';

const headerLinksCommunity = [
  { link: Path.challengeListPage, label: 'Challenges' },
  { link: Path.exerciseListPage, label: 'Exercises' },
  { link: Path.courseListPage, label: 'Courses' },
];

const headerLinksCompany = [
  { link: Path.testsPage, label: 'Tests' },
  { link: Path.sendTestPage, label: 'Send Test' },
];

const getLogoUrl = (userRole, isTicketAuth) => {
  if (isTicketAuth) return Path.candidateTicketsPage;
  if (userRole && userRole !== 'candidate') return Path.testsPage;
  return Path.landingPage;
};

const getUserUrl = (userRole, isTicketAuth, isCommunityUser) => {
  if (isTicketAuth) return Path.candidateTicketsPage;
  if (userRole && userRole !== 'candidate') return Path.testsPage;
  if (isCommunityUser) return Path.profilePage;
  return Path.landingPage;
};

const getHeaderLinks = (isInitialized, userRole, isTicketAuth) => {
  if (!isInitialized) return [];
  if (userRole && userRole !== userRoles.CANDIDATE && !isTicketAuth) return headerLinksCompany;
  if (isTicketAuth)
    return headerLinksCommunity.map((headerLink) => ({
      ...headerLink,
      link: `${headerLink.link}?c=TestUser`,
    }));
  return headerLinksCommunity;
};

export default function HeaderCompany() {
  const { isInitialized, userRole, isCommunityUser, isTicketAuth } = useSelector((state) => state.auth);

  const [isOpened, setIsOpened] = useState(false);

  const logoUrl = useMemo(() => getLogoUrl(userRole, isTicketAuth), [userRole, isTicketAuth]);

  const userUrl = useMemo(
    () => getUserUrl(userRole, isTicketAuth, isCommunityUser),
    [userRole, isTicketAuth, isCommunityUser]
  );

  const headerLinks = useMemo(
    () => getHeaderLinks(isInitialized, userRole, isTicketAuth),
    [isInitialized, userRole, isTicketAuth]
  );

  const renderHeaderLinks = () => (
    <>
      {headerLinks.map((linkData, index) => (
        <HeaderContentRow key={index}>
          <HeaderLink href={linkData.link}>{linkData.label}</HeaderLink>
        </HeaderContentRow>
      ))}
      <LinkSpacer />
    </>
  );

  const renderDropdown = () => (
    <DropdownContent>
      {renderHeaderLinks()}
      <UserDetails userRedirectUrl={userUrl} />
    </DropdownContent>
  );

  return (
    <HeaderNav>
      <a href={logoUrl}>
        <LogoImg src={Images.logo} alt="FS" />
      </a>

      <MenuIcon onClick={() => setIsOpened(!isOpened)} />
      <NavbarContents>
        {renderHeaderLinks()}
        <UserDetails userRedirectUrl={userUrl} />
      </NavbarContents>
      {isOpened && renderDropdown()}
    </HeaderNav>
  );
}
